<form
  class="bg-surface border-default flex w-full flex-col overflow-hidden rounded-lg border shadow-lg"
  aria-labelledby="swap-resources-title"
  (submit)="$event.preventDefault(); swap()">
  <div class="border-weak flex items-center gap-2 border-b px-3 py-2.5">
    <i class="text-accent-main" [class]="ICONS.arrowsLeftRight"></i>
    <h2
      id="swap-resources-title"
      class="text-text-primary min-w-0 flex-1 truncate text-sm font-semibold">
      {{ 'features.plan.edit.swap.title' | translate }}
    </h2>
    <button
      type="button"
      class="text-text-tertiary hover:text-text-primary shrink-0 cursor-pointer rounded-xs transition-colors"
      [attr.aria-label]="'common.close' | translate"
      (click)="done.emit()">
      <i [class]="ICONS.x"></i>
    </button>
  </div>

  <div class="flex flex-col gap-3 p-3">
    <div class="flex flex-col gap-1">
      <label for="swap-resources-route" class="form-label mb-0 text-xs">
        {{ 'features.plan.edit.swap.with' | translate }}
      </label>
      <app-select
        id="swap-resources-route"
        [items]="routeItems()"
        [value]="chosenOtherUid()"
        [searchable]="true"
        (valueChange)="onRoute($event)" />
      <button
        type="button"
        data-testid="swap-other-route"
        class="text-accent-main hover:text-accent-hover cursor-pointer self-start rounded-xs text-xs transition-colors"
        (click)="pickOther()">
        {{ 'features.plan.edit.move_to.other_route' | translate }}
      </button>
    </div>

    @if (a(); as routeA) {
      @if (b(); as routeB) {
        <fieldset class="m-0 min-w-0 border-0 p-0">
          <legend class="sr-only">{{ 'features.plan.edit.swap.pick' | translate }}</legend>
          <div
            class="grid grid-cols-[auto_minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-x-2 gap-y-0.5 text-sm">
            <span></span>
            <span class="text-text-secondary truncate text-right font-mono text-xs">
              {{ routeA.name }}
            </span>
            <span></span>
            <span class="text-text-secondary truncate font-mono text-xs">{{
              routeB.name
            }}</span>
            @for (row of rows; track row.key) {
              <label
                class="hover:bg-interactive has-checked:bg-accent-interactive has-focus-visible:outline-accent-focus col-span-4 grid cursor-pointer grid-cols-subgrid items-center rounded-sm px-2 py-1.5 transition-colors has-focus-visible:outline-2">
                <input
                  type="checkbox"
                  [attr.data-testid]="'swap-tick-' + row.kind"
                  class="accent-accent-main size-3.5 cursor-pointer"
                  [attr.aria-label]="'features.plan.edit.resources.' + row.kind | translate"
                  [checked]="ticked().has(row.key)"
                  (change)="toggle(row.key)" />
                <span class="text-text-primary truncate text-right font-mono">
                  {{
                    resourceName(row.kind, routeA[row.key]) ||
                      ('features.plan.edit.resources.none' | translate)
                  }}
                </span>
                <i class="text-text-tertiary" [class]="ICONS.arrowsLeftRight"></i>
                <span class="text-text-primary truncate font-mono">
                  {{
                    resourceName(row.kind, routeB[row.key]) ||
                      ('features.plan.edit.resources.none' | translate)
                  }}
                </span>
              </label>
            }
          </div>
        </fieldset>
        @if (validatedRoute()) {
          <p class="form-help" data-testid="swap-validated">
            {{ 'features.plan.edit.swap.validated' | translate }}
          </p>
        } @else {
          <p class="form-help">{{ 'features.plan.edit.swap.note' | translate }}</p>
          @if (clearedNote(); as note) {
            <p class="form-help" data-testid="swap-company-cleared">
              {{ note.key | translate: note.params }}
            </p>
          }
        }
      }
    }
  </div>

  <div class="border-weak flex items-center justify-end gap-2 border-t px-3 py-2.5">
    <button type="button" class="btn btn-cancel" (click)="done.emit()">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      type="submit"
      data-testid="swap-submit"
      class="btn btn-primary"
      [disabled]="!result()">
      {{ 'features.plan.edit.swap.swap' | translate }}
    </button>
  </div>
</form>
